import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20home%20theater%20with%20red%20velvet%20curtains%20and%20golden%20spotlights%2C%20luxurious%20movie%20theater%20interior%2C%20dramatic%20stage%20lighting%2C%20rich%20warm%20tones%2C%20elegant%20and%20mysterious%20atmosphere%2C%20professional%20photography&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="秋霞影院-免费在线观影平台"
        className="absolute inset-0 w-full h-full object-cover"
        title="秋霞影院 免费在线观影 高清影视平台"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/50 to-background-50"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-500/30 mb-8">
          <i className="ri-fire-line text-accent-400 text-sm"></i>
          <span className="text-sm text-accent-300 font-medium">每日更新 · 海量资源 · 免费观看</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight mb-6">
          畅享高清影视，<br className="hidden sm:block" />
          <span className="text-accent-400">随时随地</span>，想看在看
        </h1>

        <p className="text-base md:text-lg text-foreground-400 max-w-[600px] mx-auto mb-10 leading-relaxed">
          秋霞影院汇聚海量电影、电视剧、综艺、动漫资源，画质高清、更新快速，无需注册，打开即看。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/category/movie"
            className="px-8 py-3.5 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-200/60 hover:bg-background-300/60 text-foreground-200 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-[700px] mx-auto">
          {[
            { value: '50,000+', label: '影视资源' },
            { value: '4K', label: '超清画质' },
            { value: '100万+', label: '日均用户' },
            { value: '24h', label: '全天更新' },
          ].map((stat) => (
            <div key={stat.label} className="bg-background-100/60 backdrop-blur-sm rounded-xl px-4 py-4 border border-background-200/30">
              <div className="text-xl md:text-2xl font-heading font-bold text-accent-400">{stat.value}</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}